import { setup_type_fx } from '../modules/animations';
import { setup_masonary, feedFiltering, loadMore } from '../modules/live-feed';
import { landing_slider } from '../modules/sliders';
import LandingSheet from '../modules/landing-sheet';

export default {
	init() {
		// JavaScript to be fired on the home page
		loadMore();
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
		setup_masonary();
		feedFiltering();
		setup_type_fx();
		LandingSheet.init();
	},
	cleanup() {
		// Cleanup functions
		LandingSheet.unload();
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js